const Contacts = () => {
   return ("contacts");
};

export default Contacts;